
import Vue, { PropType } from 'vue'
import { TranslateResult } from 'vue-i18n'
import HashAnchor from '~/components/_general/HashAnchor.vue'

export default Vue.extend({
  name: 'SiteFieldSection',
  props: {
    title: {
      type: String as PropType<TranslateResult>,
      default: '',
    },
    description: {
      type: String as PropType<TranslateResult>,
      default: '',
    },
    /** Shows (Optional) after title */
    optional: {
      type: Boolean,
    },
    /** Makes the title bold */
    bold: {
      type: Boolean,
    },
    /** Spaces out items in slot by a standard amount */
    slotSpacing: {
      type: Boolean,
      default: true,
    },
    /** Adds a hash to the section and enables a hash offset */
    hash: {
      type: String,
      default: undefined,
    },
    hashOffset: {
      type: Number,
      default: 140,
    },
  },
  computed: {
    displayTitle(): TranslateResult {
      if (!this.optional) return this.title
      return `${this.title} (${this.$t('Optional')})`
    },
    hashProps(): Record<string, any> {
      if (!this.hash) return {}
      return {
        id: this.hash,
        offset: this.hashOffset,
      }
    },
    componentType(): typeof HashAnchor | string {
      if (this.hash) return HashAnchor
      return 'div'
    },
  },
})
